/* ============================================================
   Parlay — lens PDP enhancements (Donovan). Pairs with parlay-lens-pdp.css.
   Loaded ONLY on the `lens` product template. Data from window.PARLAY_*.
   Per-variant metafields: foldedImg (custom.folded_flat), bundleImg
   (custom.bundle_image), setCents (custom.bundle_price). Tiles + Both panel
   resolve them for the chosen lens + color. Lens chips from PARLAY_LENS_IMG.
   "Both" adds both lens variants and opens the cart drawer (no redirect).
   ============================================================ */
(function () {
  var D = window;
  function money(cents) { var v = (cents || 0) / 100; return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }
  function parsePrice(txt) { var m = (txt || '').replace(/[^0-9.]/g, ''); return m ? Math.round(parseFloat(m) * 100) : 0; }
  function VARS() { return D.PARLAY_VARIANTS || []; }
  function CP() { return (D.PARLAY_COLOR_POS || 2) - 1; }
  function LP() { return (D.PARLAY_LENS_POS || 1) - 1; }
  function isEvening(v) { return /dusk|evening|night/.test((v || '').toLowerCase()); }

  function currentColor(colorFs) {
    if (!colorFs) return null;
    var c = colorFs.querySelector('input[type="radio"]:checked');
    return c ? (c.getAttribute('data-option-value') || c.value) : null;
  }
  function currentLens(lensFs) {
    if (!lensFs) return null;
    var c = lensFs.querySelector('input[type="radio"]:checked');
    return c ? (c.getAttribute('data-option-value') || c.value) : null;
  }
  function foldedFor(lens, color) {
    var lp = LP(), cp = CP(), exact = '', anyColor = '';
    VARS().forEach(function (v) {
      var o = v.opts || [];
      if (color != null && o[cp] !== color) return;
      if (v.foldedImg) {
        if (!anyColor) anyColor = v.foldedImg;
        if (lens != null && o[lp] === lens && !exact) exact = v.foldedImg;
      }
    });
    return exact || anyColor;
  }
  function bundleImgForColor(color) {
    var cp = CP(), out = '';
    VARS().forEach(function (v) { if (out) return; var o = v.opts || []; if ((color == null || o[cp] === color) && v.bundleImg) out = v.bundleImg; });
    return out;
  }
  function variantIntro(lens, color) {
    var lp = LP(), cp = CP(), out = '';
    VARS().forEach(function (v) {
      if (out) return; var o = v.opts || [];
      if ((lens == null || o[lp] === lens) && (color == null || o[cp] === color)) out = v.intro || '';
    });
    return out;
  }
  function setCentsForColor(color) {
    var cp = CP(), out = 0;
    VARS().forEach(function (v) { if (out) return; var o = v.opts || []; if ((color == null || o[cp] === color) && v.setCents) out = v.setCents; });
    return out || 11400;
  }
  function lensPairFor(color) {
    var cp = CP(), lp = LP(), day = null, evening = null;
    VARS().forEach(function (v) {
      var o = v.opts || [];
      if (color != null && cp >= 0 && o[cp] !== color) return;
      if (isEvening(o[lp])) { if (!evening) evening = v; }
      else if (!day) day = v;
    });
    return { day: day, evening: evening };
  }
  function setNumbers(color) {
    var pair = lensPairFor(color);
    var single = (pair.day && pair.day.price) || 0;
    var setCents = setCentsForColor(color);
    var cmpCents = ((pair.day && (pair.day.compare || pair.day.price)) || 0) + ((pair.evening && (pair.evening.compare || pair.evening.price)) || 0);
    return { pair: pair, single: single, set: setCents, compare: cmpCents, save: cmpCents - setCents, second: setCents - single };
  }
  function lensChip(kind) {
    var m = D.PARLAY_LENS_IMG || {};
    var src = kind === 'evening' ? m.evening : m.day;
    return src ? '<img class="parlay-lens-thumb" src="' + src + '" alt="" aria-hidden="true">' : '';
  }

  /* ---- Add-to-cart button price (stateless: recomputed every enhance) ----
     Both active  -> bundle price (custom.bundle_price for the color)
     otherwise    -> the selected variant's single price.
     The theme's toggleSubmitButton only rewrites the label span now, so the
     text we set on <product-buy-price> survives variant-change morphs; we still
     re-assert it on every pass so it never sticks on a stale value. */
  function money2(cents) { return '$' + ((cents || 0) / 100).toFixed(2); }
  function bothIsActive(root) { return !!root.querySelector('.swatches.parlay-both-active'); }
  function currentVariantCents(lens, color) {
    var lp = LP(), cp = CP(), out = null;
    VARS().forEach(function (v) {
      if (out != null) return; var o = v.opts || [];
      if ((lens == null || o[lp] === lens) && (color == null || o[cp] === color)) out = v.price;
    });
    return out;
  }
  function syncAtcPrice(root, lensFs, colorFs) {
    var el = root.querySelector('.sr-atc__main product-buy-price');
    if (!el) return;
    var color = currentColor(colorFs);
    var cents = bothIsActive(root) ? setCentsForColor(color) : currentVariantCents(currentLens(lensFs), color);
    if (cents != null) el.textContent = money2(cents);
  }

  function enhance() {
    var root = document.querySelector('#MainContent');
    if (!root) return;
    var lensFs = root.querySelector('fieldset[data-option-slug="lens"]');
    var colorFs = root.querySelector('fieldset[data-option-slug="color"]');

    if (lensFs && colorFs && lensFs.parentNode === colorFs.parentNode) {
      if (lensFs.compareDocumentPosition(colorFs) & Node.DOCUMENT_POSITION_FOLLOWING) {
        lensFs.parentNode.insertBefore(colorFs, lensFs);
      }
    }

    /* Caption above the benefits — per lens block, following the variant's intro (day/night fallback) */
    var lensNow = currentLens(lensFs);
    var vIntro = variantIntro(lensNow, currentColor(colorFs));
    var dayCap = 'Burning eyes, brain fog, afternoon crash? Parlay’s Everyday lens filters the harsh blue spike from screens — so your focus holds, your eyes calm down, and your energy stays steady. Filters 95% of blue light, 400–465nm.';
    var nightCap = 'Tired but wired, can’t fall asleep, waking up groggy? Parlay’s Dusk lens blocks the blue and green light that shuts down melatonin — so you wind down, fall asleep faster, and wake up clear. Filters ~99% of blue and green light, 400–570nm.';
    var capText = (vIntro && vIntro.trim()) || (isEvening(lensNow) ? nightCap : dayCap);
    root.querySelectorAll('.benefit-ticks').forEach(function (bt) {
      var cap = bt.previousElementSibling;
      if (!cap || !cap.classList || !cap.classList.contains('parlay-caption')) {
        cap = document.createElement('p'); cap.className = 'parlay-caption';
        bt.parentNode.insertBefore(cap, bt);
      }
      cap.textContent = capText;
    });

    /* "Designed to help you:" heading above each bullet list. Injected here
       (the block-schema setting doesn't reliably surface via GitHub sync);
       dedupes against any server-rendered .benefit-ticks__intro. */
    root.querySelectorAll('.benefit-ticks').forEach(function (bt) {
      if (bt.querySelector('.benefit-ticks__intro')) return;
      var list = bt.querySelector('.benefit-ticks__list');
      if (!list) return;
      var intro = document.createElement('p');
      intro.className = 'benefit-ticks__intro';
      intro.textContent = 'Designed to help you:';
      list.parentNode.insertBefore(intro, list);
    });

    var ll = lensFs && lensFs.querySelector('.form__label');
    if (ll && !ll.dataset.parlayRelabelled) { ll.textContent = 'Choose lens type'; ll.dataset.parlayRelabelled = '1'; }
    var cl = colorFs && colorFs.querySelector('.form__label');
    if (cl && !cl.dataset.parlayRelabelled) {
      /* relabel only the inner text node so a right-aligned size-chart sibling survives */
      var clText = cl.querySelector('.flex');
      if (clText) { clText.textContent = 'Choose frame color'; } else { cl.textContent = 'Choose frame color'; }
      cl.dataset.parlayRelabelled = '1';
    }

    /* Lens chips + rename Everyday/Dusk -> Day/Night (display only; variant values unchanged) */
    if (lensFs) {
      lensFs.querySelectorAll('.label-swatch').forEach(function (lb) {
        if (lb.dataset.parlayLens) return;
        var v = (lb.getAttribute('title') || lb.textContent || '').trim();
        var evening = isEvening(v);
        var name = evening ? 'Night' : 'Day';
        lb.dataset.parlayLens = name;
        lb.innerHTML = lensChip(evening ? 'evening' : 'day') + '<span class="parlay-lens-name">' + name + '</span>';
      });
    }

    /* Color tiles — image follows the SELECTED lens (day vs dusk) */
    if (colorFs) {
      var lensNow = currentLens(lensFs);
      colorFs.querySelectorAll('label.color-swatch').forEach(function (lb) {
        var val = (lb.getAttribute('title') || '').trim();
        var img = foldedFor(lensNow, val);
        if (img) lb.style.setProperty('--swatch-background-image', 'url("' + img + '")');
        // Name sits as a caption BELOW the photo tile (not overlaid on it), so
        // long names like "Tortoise / Ion Clear" read cleanly instead of
        // stacking over the image. Append to the tile's host, not the label.
        var host = lb.parentNode;
        if (host && !host.querySelector('.parlay-tile-name')) {
          var n = document.createElement('span'); n.className = 'parlay-tile-name';
          n.textContent = val.replace(/\s*\/\s*/g, ' / ');
          host.appendChild(n);
        }
      });
    }

    buildBoth(root, lensFs, colorFs);
    wireAtcBoth(root, lensFs, colorFs);
    buildGifts(root);
    syncAtcPrice(root, lensFs, colorFs);
  }

  function buildBoth(root, lensFs, colorFs) {
    if (!lensFs) return;
    var ul = lensFs.querySelector('.swatches');
    if (!ul || ul.querySelector('.parlay-lens-both')) return;
    var p0 = lensPairFor(currentColor(colorFs));
    if (!p0.day || !p0.evening) return;

    var li = document.createElement('li');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'parlay-lens-both'; btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="parlay-lens-thumbs" aria-hidden="true">' + lensChip('day') + lensChip('evening') + '</span>Both';
    li.appendChild(btn); ul.appendChild(li);

    var reveal = document.createElement('div');
    reveal.className = 'parlay-lens-reveal';
    lensFs.appendChild(reveal);

    function updatePanel() {
      var color = currentColor(colorFs);
      var n = setNumbers(color);
      var photoSrc = bundleImgForColor(color) || foldedFor(currentLens(lensFs), color) || '';
      reveal.innerHTML =
        '<div class="parlay-lens-panel">' +
          (photoSrc ? '<img class="parlay-lens-panel-photo" src="' + photoSrc + '" alt="Day / Night set">' : '') +
          '<div class="parlay-lens-panel-body">' +
            '<p class="parlay-lens-panel-title">You’re covered day and night</p>' +
            '<p class="parlay-lens-panel-sub">Both lenses in this frame — Day for your screens, Night for your wind-down.</p>' +
            '<div class="parlay-lens-panel-priceline"><span class="parlay-lens-panel-price">' + money(n.set) + '</span>' +
              (n.save > 0 ? '<s class="parlay-lens-panel-compare">' + money(n.compare) + '</s>' : '') + '</div>' +
            (n.second > 0 && n.second < n.set ? '<div><span class="parlay-lens-panel-save">Second pair only ' + money(n.second) + '</span></div>' : '') +
          '</div>' +
        '</div>';
      var flag = btn.querySelector('.parlay-lens-flag');
      if (n.save > 0 && n.compare > 0) {
        if (!flag) { flag = document.createElement('span'); flag.className = 'parlay-lens-flag'; btn.appendChild(flag); }
        flag.textContent = 'Save ' + Math.round(n.save / n.compare * 100) + '%';
      } else if (flag) { flag.remove(); }
      syncAtcPrice(root, lensFs, colorFs);
    }
    updatePanel();

    var openBoth = function () { ul.classList.add('parlay-both-active'); btn.classList.add('is-active'); btn.setAttribute('aria-expanded', 'true'); reveal.classList.add('is-open'); syncAtcPrice(root, lensFs, colorFs); };
    var closeBoth = function () { ul.classList.remove('parlay-both-active'); btn.classList.remove('is-active'); btn.setAttribute('aria-expanded', 'false'); reveal.classList.remove('is-open'); syncAtcPrice(root, lensFs, colorFs); };
    btn.addEventListener('click', function () { btn.classList.contains('is-active') ? closeBoth() : openBoth(); });
    lensFs.querySelectorAll('input[type="radio"]').forEach(function (r) { r.addEventListener('change', closeBoth); });
    // Clicking a lens option exits Both even when that lens is already the checked
    // radio (no `change` fires) — this is the "go back to the lens I came from" case.
    lensFs.querySelectorAll('.label-swatch').forEach(function (l) { l.addEventListener('click', closeBoth); });
    if (colorFs) colorFs.querySelectorAll('input[type="radio"]').forEach(function (r) { r.addEventListener('change', updatePanel); });
  }

  /* When "Both" is active, the normal Add-to-cart adds BOTH lens variants + opens the drawer. */
  function wireAtcBoth(root, lensFs, colorFs) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.parlayBothWired) return;
    form.dataset.parlayBothWired = '1';
    function bothActive() { return !!root.querySelector('.swatches.parlay-both-active'); }
    function addBoth(e) {
      if (!bothActive()) return;
      var pair = lensPairFor(currentColor(colorFs));
      if (!pair.day || !pair.evening) return;
      e.preventDefault(); e.stopImmediatePropagation();
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: pair.day.id, quantity: 1 }, { id: pair.evening.id, quantity: 1 }] })
      }).then(function (res) {
        // Concept's cart drawer refreshes + opens on this event (parlay-cart-bridge also fires it).
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') { try { drawer.show(); } catch (er) {} }
      });
    }
    form.addEventListener('submit', addBoth, true);
    var btn = form.querySelector('.product-form__submit, [type="submit"], button[name="add"]');
    if (btn) btn.addEventListener('click', addBoth, true);
  }

  /* ---------- Gifts: bar + modal (tap anywhere to close) ---------- */
  function findGiftBlock(root) {
    var direct = root.querySelector('[class*="pfg2-free_gifts"]');
    if (direct) return direct;
    var strike = root.querySelector('.pfg2__strike');
    if (strike) {
      var el = strike;
      for (var i = 0; i < 7 && el.parentElement; i++) {
        el = el.parentElement;
        if ((el.className || '').toString().indexOf('pfg2') > -1 && el.querySelectorAll('.pfg2__strike').length > 1) return el;
      }
    }
    return null;
  }
  function parseGifts(block) {
    var gifts = [], seen = {};
    block.querySelectorAll('.pfg2__strike').forEach(function (s) {
      var card = s;
      for (var i = 0; i < 5 && card.parentElement; i++) { card = card.parentElement; if (card.querySelector('img')) break; }
      var img = card.querySelector('img');
      var titleEl = card.querySelector('[class*="title"], [class*="name"]');
      var name = titleEl ? titleEl.textContent.trim() : '';
      var key = name || s.textContent;
      if (seen[key]) return; seen[key] = 1;
      gifts.push({ name: name, price: s.textContent.trim(), img: img ? (img.getAttribute('src') || img.src) : '' });
    });
    return gifts;
  }
  function buildGifts(root) {
    if (root.querySelector('.parlay-giftbar')) return;
    var block = findGiftBlock(root);
    if (!block) return;
    var gifts = parseGifts(block);
    if (!gifts.length) return;
    var total = gifts.reduce(function (a, g) { return a + parsePrice(g.price); }, 0);
    var totalTxt = total ? '~' + money(Math.round(total / 1000) * 1000) : '';
    // Bar copy comes from the block's theme-editor settings: title = the block
    // heading (already holds any rolled (min-max) number), sub/link = data attrs.
    if (window.pfg2Randomize) window.pfg2Randomize(block);
    var headingEl = block.querySelector('.pfg2__rail-heading, .pfg2__receipt-heading, .pfg2__check-heading, .pfg2__box-eyebrow, .pfg2__bar-heading, .pfg2__glassrail-heading');
    var titleHtml = headingEl && headingEl.innerHTML.trim() ? headingEl.innerHTML : 'FREE Gifts Included';
    var subTxt = (block.getAttribute('data-giftbar-sub') || '').trim();
    if (subTxt) {
      subTxt = subTxt.replace('[value]', totalTxt);
      var rnColor = (block.getAttribute('data-randnum-color') || '').trim();
      var rnMode = block.getAttribute('data-randnum-mode') || 'countdown';
      var rnIv = (parseInt(block.getAttribute('data-randnum-interval'), 10) || 60) * 60000;
      subTxt = subTxt.replace(/\((\d+)\s*-\s*(\d+)\)/, function (m, a, b) {
        a = parseInt(a, 10); b = parseInt(b, 10);
        if (b < a) { var t = a; a = b; b = t; }
        var n = rnMode === 'random'
          ? String(Math.floor(Math.random() * (b - a + 1)) + a)
          : String(b - (Math.floor(Date.now() / rnIv) % (b - a + 1)));
        return rnColor ? '<span style="color: ' + rnColor + '">' + n + '</span>' : n;
      });
    } else {
      subTxt = totalTxt ? totalTxt + ' worth of gifts' : gifts.length + ' free extras';
    }
    var subSep = /[.!?…]\s*$/.test(subTxt) ? ' ' : '. ';
    var linkTxt = (block.getAttribute('data-giftbar-link') || '').trim() || 'See gifts';
    block.style.display = 'none';

    var bar = document.createElement('div');
    bar.className = 'parlay-giftbar'; bar.setAttribute('role', 'button'); bar.setAttribute('tabindex', '0');
    bar.innerHTML =
      '<div class="parlay-giftbar__text">' +
        '<p class="parlay-giftbar__title">' + titleHtml + '</p>' +
        '<p class="parlay-giftbar__sub">' + subTxt + subSep + '<span class="parlay-giftbar__link">' + linkTxt + '</span></p>' +
      '</div>' +
      '<div class="parlay-giftbar__thumbs">' +
        gifts.map(function (g) { return '<span class="parlay-giftbar__thumb">' + (g.img ? '<img src="' + g.img + '" alt="' + g.name + '">' : '') + '</span>'; }).join('') +
      '</div>';
    block.parentNode.insertBefore(bar, block.nextSibling);

    var modal = document.createElement('div');
    modal.className = 'parlay-modal';
    modal.innerHTML =
      '<div class="parlay-modal__overlay"></div>' +
      '<div class="parlay-modal__card" role="dialog" aria-modal="true" aria-label="Your free gifts">' +
        '<button class="parlay-modal__close" aria-label="Close">×</button>' +
        '<p class="parlay-modal__eyebrow">Included free</p>' +
        '<h3 class="parlay-modal__title">Your free gifts</h3>' +
        '<p class="parlay-modal__lead">Every order ships with these extras — no code needed.</p>' +
        '<div class="parlay-modal__list">' +
          gifts.map(function (g) {
            return '<div class="parlay-giftrow">' +
              '<div class="parlay-giftrow__media">' + (g.img ? '<img src="' + g.img + '" alt="' + g.name + '">' : '') + '</div>' +
              '<div class="parlay-giftrow__body"><p class="parlay-giftrow__name">' + g.name + '</p></div>' +
              '<div class="parlay-giftrow__price"><s class="parlay-giftrow__strike">' + g.price + '</s><span class="parlay-giftrow__free">FREE</span></div>' +
            '</div>';
          }).join('') +
        '</div>' +
        (total ? '<div class="parlay-modal__total"><span class="parlay-modal__total-label">Total gift value</span><span class="parlay-modal__total-value"><s>' + totalTxt + '</s><b>Free</b></span></div>' : '') +
      '</div>';
    document.body.appendChild(modal);

    var openM = function () { modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
    var closeM = function () { modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
    bar.addEventListener('click', openM);
    bar.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openM(); } });
    modal.addEventListener('click', closeM);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeM(); });
  }

  function boot() {
    var main = document.querySelector('#MainContent') || document.body;
    var obs;
    var timer = null;
    function runEnhance() {
      timer = null;
      // Disconnect while we mutate so (a) our own writes don't re-trigger us and
      // (b) we don't interleave with the theme's variant-change morph (which was
      // dropping the price element). Reconnect once the DOM has settled.
      if (obs) obs.disconnect();
      try { enhance(); } finally { if (obs) obs.observe(main, { childList: true, subtree: true }); }
    }
    function schedule() { if (timer) return; timer = setTimeout(runEnhance, 130); }
    obs = new MutationObserver(schedule);
    enhance();
    obs.observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
